function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Smoke_alarm"
}, /*#__PURE__*/React.createElement("title", null, "VF_smoke_alarm_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 21.3H0v92.1h32.7L54 170.1h175.5l21.3-56.7h32.7V21.3zM28.3 49.6h226.8V85H28.3V49.6zm141.8 63.8v28.3h-56.7v-28.3h56.7zm-107.1 0h22v28.3H73.6L63 113.4zm146.9 28.3h-11.5v-28.3h22.1l-10.6 28.3zM141.7 233.9c-12.6 0-25.1-2.1-37-6.1l-14.2 24.9c33 12.7 69.5 12.7 102.5 0l-14.2-24.9c-12 4-24.5 6.1-37.1 6.1zM157 189.7c-10 2.2-20.4 2.2-30.5 0L112 215.1c19.4 6.1 40.2 6.1 59.6 0L157 189.7z"
}))));